import styled from 'styled-components';
import { Typography } from '@wearehelpful/ui-kit';

export const Container = styled('div')<{ cols: number }>`
  display: grid;
  gap: ${({ theme: { spacing } }) => spacing(1)};
  grid-template-columns: repeat(${({ cols }) => cols}, 1fr);
  padding: 0 ${({ theme: { spacing } }) => spacing(4)};
`;

export const Column = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { spacing } }) => spacing(1)};
`;

export const Cell = styled('div')``;

export const Title = styled(Typography)`
  padding: ${({ theme: { spacing } }) => spacing(4)} 0;
  text-transform: capitalize;
`;

export const Heading = styled(Typography)`
  display: flex;
  height: ${({ theme: { spacing } }) => spacing(10)};
  align-items: center;
  justify-content: center;
`;
